import React from 'react';
import { Box } from '@chakra-ui/react';

/** Serving marker. */
export const TennisServeBall: React.FC<{ size?: number }> = ({ size = 10 }) => (
  <Box as="span" display="inline-block" w={`${size}px`} h={`${size}px`} borderRadius="full" bg="yellow.300"
       borderWidth="1px" borderColor="yellow.600" title="Serves next" flexShrink={0} />
);

export default TennisServeBall;
